if (!customElements.get('results-toolbar')) {
  customElements.define(
    'results-toolbar',
    class ResultsToolbar extends window.BAO.CustomElement() {
      constructor () {
        super()
        this.eventBus = window.theme.results.eventBus
      }

      connectedCallback () {
        super.connectedCallback()
        this.onProductsUpdated = this.renderToolbar.bind(this)

        this.eventBus.subscribe(
          window.theme.results.events.STATE.PRODUCTS_UPDATED,
          this.onProductsUpdated,
        )

        this.eventBus.subscribe(
          window.theme.results.events.STATE.SEARCH_TOTAL_UPDATED,
          this.renderExternalTotal.bind(this),
        )
      }

      renderToolbar ({ products }) {
        if (products.length === 0) {
          this.setAttribute('hidden', 'true')
        } else {
          this.removeAttribute('hidden')
        }
      }

      renderExternalTotal ({ total, activeTerm }) {
        const totalEl = document.querySelector('[data-search-header-text]')
        if (totalEl) {
          totalEl.textContent = `Showing ${total} results found for '${activeTerm}'`
        }
      }
    },
  )
}
